import React from 'react';
import { Offer, useFeatureFlags } from '@funtech-int/yango-shared';

import { useOfferDisplayData } from '../../hooks/useOfferDisplayData';
import { featureFlagsScheme } from '../../lib/featureFlags';

import { DefaultPlan, WidePlan } from './plans';

interface MultiOfferPlanProps {
    selected: boolean;
    offer: Offer;
    isWideMultiOfferDesktopEnabled: boolean;
    onClick: VoidFunction;
}

export const MultiOfferPlan = ({
    selected,
    offer,
    isWideMultiOfferDesktopEnabled,
    onClick,
}: MultiOfferPlanProps) => {
    const { flags } = useFeatureFlags(featureFlagsScheme);
    const isNewYearAnnualOfferEnabled = flags.get('isNewYearAnnualOfferEnabled');

    const {
        title,
        subtitle,
        additionalText,
        priceText,
        badgeText,
        innerBadgeText,
        oldPrice,
        price,
        period,
        currency,
    } = useOfferDisplayData(offer);

    if (isWideMultiOfferDesktopEnabled) {
        return (
            <WidePlan
                badgeText={badgeText}
                selected={selected}
                title={title}
                subtitle={subtitle}
                additionalText={additionalText}
                priceText={priceText}
                onClick={onClick}
            />
        );
    }

    if (isNewYearAnnualOfferEnabled) {
        return (
            <DefaultPlan
                badgeText={innerBadgeText}
                selected={selected}
                title={title}
                subtitle={subtitle}
                price={price}
                currency={currency}
                period={period}
                onClick={onClick}
                oldPrice={oldPrice}
            />
        );
    }

    return (
        <DefaultPlan
            badgeText={badgeText}
            selected={selected}
            title={title}
            subtitle={subtitle}
            price={price}
            currency={currency}
            period={period}
            onClick={onClick}
        />
    );
};
